// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d79519c2","453":"6c8f8aed","726":"63e59fed","806":"f7e8cbb2"}[chunkId] + ".chunk.js";
};